import React from 'react';

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center m-14">
      © 2023 All rights reserved by BooksPie.com
    </p>
  </div>
);

export default Footer;